/**
 * SSOT-84 / #10193 — strip common Markdown markers from penalty notes for plain UI.
 */

export function stripMarkdownLight(text: string | null | undefined): string {
  if (text == null) return "";
  let out = String(text);
  // Bold / italic markers (no lookbehind — older browser targets)
  out = out.replace(/\*\*(.+?)\*\*/g, "$1");
  out = out.replace(/__(.+?)__/g, "$1");
  out = out.replace(/\*([^*\n]+)\*/g, "$1");
  out = out.replace(/_([^_\n]+)_/g, "$1");
  // Inline code / links
  out = out.replace(/`([^`]+)`/g, "$1");
  out = out.replace(/\[([^\]]+)\]\(([^)]+)\)/g, "$1");
  // Remaining lone ** artifacts
  out = out.replace(/\*\*/g, "");
  return out.trim();
}
